var map = {
	"./advice.svg": 2631,
	"./bandage.svg": 8455,
	"./blob_mam_services.svg": 3310,
	"./blob_service.svg": 2822,
	"./book-appointment.svg": 5656,
	"./cat.svg": 9530,
	"./doctor.svg": 4456,
	"./dog.svg": 1715,
	"./home-visit.svg": 3234,
	"./hospital.svg": 178,
	"./knife.svg": 3754,
	"./online-consultation.svg": 143,
	"./vaccine.svg": 8175,
	"./writing_pad.svg": 5869
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6057;